export default __webpack_public_path__ + "static/media/single-project-page-04-img08.d3a265b7.jpg";